import type { EpgGridTimelineAnchor } from "$src/core/models/epg";

/** Stable key fragment so program FlatLists remount when day or data changes. */
const getProgramListRemountKey = ({
  timelineScrollAnchor,
}: {
  timelineScrollAnchor?: EpgGridTimelineAnchor;
}): string | null => {
  if (!timelineScrollAnchor) {
    return null;
  }

  return [
    timelineScrollAnchor.selectedDateOffset,
    timelineScrollAnchor.dayStart.getTime(),
    timelineScrollAnchor.dayReferenceMs,
  ].join("-");
};

export default getProgramListRemountKey;
